export interface Product {
  id: string
  productCode: string
  productMeta: null | object
}
